export default __webpack_public_path__ + "static/media/Products Sample XLSX - Add Products Here.8fc833a4.xlsx";